import { LORAX, OLAF } from 'HubStyleTokens/colors';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flow } from 'signup-constants/Flow';
import { SignupQueryKeys } from 'signup-constants/SignupQueryKeys';
import { HubsTrackingAttr } from 'signup-constants/HubsTrackingAttr';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import { addUrlParams } from 'LearningCenterUI/utils/RoutingUtils';
import { useCallback } from 'react';
import { getBrochureRoot, useAchievementTracks, useAchievementUser } from '../../../features/achievement';
import ViralTrackingPixel from 'viral-links-lib/viral-tracking/ViralTrackingPixel';
import { getTrackedSignupUrl } from 'viral-links-lib/viral-tracking/viral-urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FooterCTABar = styled.div.withConfig({
  displayName: "FooterCTA__FooterCTABar",
  componentId: "jk4zx7-0"
})(["background:", ";padding:10px;width:100%;color:", ";text-align:center;position:fixed;bottom:0;& .want-to-grow{display:none;}@media (min-width:", "){text-align:right;.want-to-grow{display:inline-block;margin:0 1em 0 0;}}"], LORAX, OLAF, GRID_BREAKPOINT_SMALL);
const addCtaParam = (href, cta) => addUrlParams(href, {
  'hubs_content-cta': cta
});
const BUTTON_TYPES = {
  SIGNUP: 'signup',
  ACADEMY_HOME: 'academyHome'
};
const FooterCTA = ({
  trackEvent,
  publicId,
  language
}) => {
  const tracks = useAchievementTracks(publicId);
  const track = tracks && tracks[0];
  const user = useAchievementUser(publicId);
  const brochureRoot = getBrochureRoot(language);
  const userId = user && user.userId;
  const viralLinkType = 'academy-achievements';
  const signupUrl = getTrackedSignupUrl({
    flow: Flow.Academy,
    viralLinkType,
    additionalParams: {
      [SignupQueryKeys.OptSidebar]: 'true',
      [SignupQueryKeys.Intent]: 'learningCenter',
      [HubsTrackingAttr.Campaign]: 'hubspot-academy-achievements-virality',
      [HubsTrackingAttr.Medium]: 'virality',
      track: track ? track.id : '',
      viralSourceUserId: userId ? userId.toString() : '',
      'hubs_signup-url': window.location.href,
      'hubs_signup-cta': 'achievement-cta-sticky'
    }
  });
  const getButtonClickHandler = useCallback(buttonType => ({
    currentTarget
  }) => trackEvent({
    action: 'click-footer-cta-button',
    buttonType,
    href: currentTarget.href,
    isExternalLink: true
  }), [trackEvent]);
  return /*#__PURE__*/_jsxs(FooterCTABar, {
    "data-test-id": "virality-footer",
    children: [/*#__PURE__*/_jsx("strong", {
      className: "want-to-grow",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.certification.signupCta.wantToGrow"
      })
    }), userId ? /*#__PURE__*/_jsx(ViralTrackingPixel, {
      userId: userId,
      viralLinkType: viralLinkType
    }) : /*#__PURE__*/_jsx(ViralTrackingPixel, {
      viralLinkType: viralLinkType
    }), /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "virality-button",
      href: signupUrl,
      onClick: getButtonClickHandler(BUTTON_TYPES.SIGNUP),
      responsive: false,
      use: "primary-white",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.certification.signupCta.signUp"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      href: addCtaParam(brochureRoot, 'achievement-cta-find-my-own'),
      onClick: getButtonClickHandler(BUTTON_TYPES.ACADEMY_HOME),
      responsive: false,
      use: "secondary-ghost",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.certification.signupCta.findOwnCourses"
      })
    })]
  });
};
export default FooterCTA;